var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-card-wrapper"},[_vm._l((_vm._numArr),function(item,index){return [_c('number-card',{key:index,attrs:{"value":+item,"delay":index}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }